// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system-log-modal .sk-modal__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-width: 80%;\n  height: 100%;\n  background-color: #e9ebef;\n}\n.system-log-modal iframe {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
